<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-badge-dollar" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{ discount.title }}</div>
            <div class="meta mt-1"><b-tag type="is-primary"><i class="far fa-badge-dollar mr-2"></i>{{discount.code}}</b-tag></div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat">
                    <span v-if="discount.type === 'amount'">{{ discount.value | currency }} off</span>
                    <span v-if="discount.type === 'percent'">{{ discount.value }}% Off</span>
                </span>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'RmcDiscountTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            discount: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: orangered;
        }
    }
</style>
